import React from "react"
import Select from "react-select"

const SearchTypeDropdown = ({ selectOptions, sortByVal, handleChange }) => {
  // console.log("searchTypeVal ==>", searchTypeVal, SearchType[searchTypeVal])

  const sortOptions = []
  selectOptions.map((item) =>
    sortOptions.push({
      label: item.label,
      value: `${process.env.GATSBY_ALGOLIA_INDEX_NAME}_${item.value}`,
    }),
  )
  return (
    <div className="select-option dropdown sort-by">
      <span className="sm-text">Sort:</span>
      <Select
        options={sortOptions}
        placeholder="Highest Price"
        className="react-select"
        classNamePrefix="react-select"
        onChange={(event) => handleChange(event.value)}
        value={sortOptions.filter((item) => item.value === sortByVal)}
      />
    </div>
  )
}
export default SearchTypeDropdown
